<template>
  <div>
    <div class="title">
      <h3 class="left">Facturation</h3>
    </div>

    <div class="general-lists">
      <div class="table-responsive">
        <div id="basicTable_wrapper" class="dataTables_wrapper form-inline no-footer">
          <table id="basicTable" role="grid" class="table table-hover dataTable no-footer">
            <tbody>
            <tr>
              <td class="v-align-middle"><span>Mode de règlement</span></td>
              <td class="v-align-middle"><span>Prélèvement automatique</span></td>
              <td class="v-align-middle"><button class="btn btn-default btn-sm">Modifier</button></td>
            </tr>
            <tr>
              <td class="v-align-middle"><span>Périodicité</span></td>
              <td class="v-align-middle"><span>Mensuelle</span></td>
              <td class="v-align-middle"><button class="btn btn-default btn-sm">Modifier</button></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script type="text/babel">
  export default{}
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/Domiciliation/Payment.vue